import { render, staticRenderFns } from "./finish_kecermatan.vue?vue&type=template&id=01caa795&"
import script from "./finish_kecermatan.vue?vue&type=script&lang=js&"
export * from "./finish_kecermatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports